import React, { FunctionComponent } from 'react';
import { Alert } from '../component';
import { AlertTypeUtility } from './AlertTypeUtility';
import { CsaTagProps } from '../csa/utils';

interface PillPackComBannerProps {
    alert: Alert;
    csaTagProps: CsaTagProps;
}

const PillPackComBanner: FunctionComponent<PillPackComBannerProps> = ({ alert, csaTagProps }) => {
    const article = alert.article;
    const { imgClass, textColor } = AlertTypeUtility.getAlertTypeMapValues(alert.alertType);

    return (
        <pui-stack direction="vertical" spacingBottom="small" spacingTop="none">
            <pui-stack direction="horizontal" mainAxisArrangement="start">
                <pui-icon imgclass={imgClass} spacingRight="mini"></pui-icon>
                <pui-text inline textColor={textColor} input={article.headline}></pui-text>
            </pui-stack>
        </pui-stack>
    );
};

export default PillPackComBanner;